export const ERROR_KEY = 'showError';
export const ERROR_KEY_VALUE = 'true';

export type ExercisePeerReviewProps = {
  exerciseId: string;
};
